import styled from 'styled-components'
import Tag from '../../../ui/Tag/Tag'

export interface BadgeCellProps {
  label: string
  color: string
}

/** Generic status pill: a leading colored dot + tinted label. Color is data-driven. */
export const BadgeCell = ({ label, color }: BadgeCellProps) => (
  <Tag variant="tinted" color={color}>
    <Inner>
      <Dot $color={color} />
      {label}
    </Inner>
  </Tag>
)

export default BadgeCell

const Inner = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`

const Dot = styled.span<{ $color: string }>`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ $color }) => $color};
`
